export const ENTITY_STATUSES_OPTIONS = [
  { label: 'New', value: 5, id: 'New' },
  { label: 'Review', value: 0, id: 'Review' },
  { label: 'Approved', value: 4, id: 'Approved' },
];
